import { render, staticRenderFns } from "./FinanceList.vue?vue&type=template&id=0b1860ba"
import script from "./FinanceList.vue?vue&type=script&lang=js"
export * from "./FinanceList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports